import { PRIORITIES } from '@/core/constants/installation-priorities.constant'
import { useAuthStore } from '@/modules/auth/stores/auth.store'
import { startPendingSubmissionOffer } from '@/shared/services/session/pending-submission.service'
import { startSessionExpiryWarning } from '@/shared/services/session/session-expiry-warning.service'

export const priority = PRIORITIES.SESSION_EXPIRY

export function install() {
  const authStore = useAuthStore()
  startSessionExpiryWarning({ authStore })
  startPendingSubmissionOffer({ authStore })
}
